// src/pages/DashboardNavigation/components/NavigationSkeleton.jsx

import React from "react";

export default function NavigationSkeleton() {
  return (
    <div className="rounded-[1.5rem] border border-slate-200/80 bg-white/95 p-2 shadow-sm dark:border-slate-800 dark:bg-slate-900/95">
      <div className="h-[92px] animate-pulse rounded-[1.25rem] bg-slate-100 dark:bg-slate-800" />
    </div>
  );
}